import React from "react";

function KpiTile({ label, value, unit, testId }) {
  return (
    <div className="k-card p-6" data-testid={testId}>
      <div className="k-sublabel">{label}</div>
      <div className="mt-3 flex items-baseline gap-2">
        <span className="text-4xl font-semibold font-heading text-[#156F5B]">{value}</span>
        {unit && <span className="text-xs text-[#6B7280] font-heading">{unit}</span>}
      </div>
    </div>
  );
}

export function EnergyKpiStrip({ summary }) {
  const topSite = summary?.sites?.[0];
  return (
    <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <KpiTile label="Total Demand" value={summary ? summary.total_demand_kw.toLocaleString() : "…"} unit="kW" testId="energy-kpi-demand" />
      <KpiTile label="Metered Sites" value={summary ? summary.metered_sites : "…"} testId="energy-kpi-sites" />
      <KpiTile label="Top Consumer" value={topSite ? topSite.site_dis : "—"} testId="energy-kpi-top" />
      <KpiTile
        label="Top Site Demand"
        value={topSite?.demand_kw != null ? topSite.demand_kw.toLocaleString() : "—"}
        unit="kW"
        testId="energy-kpi-top-demand"
      />
    </div>
  );
}
